export default __webpack_public_path__ + "static/media/customize-icon.367468c9.svg";